export default __webpack_public_path__ + "static/media/homepage_blocco1-fotoA.676a9a93.jpg";